export const MerchantInfoCardStyles = {
  container:
    'w-full mt-6 shadow-md mx-8 h-min-320 h-max-328 flex flex-col bg-white sm:w-7/12 lg:w-5/12',
  contactInfoContainer:
    'w-full flex flex-col items-start justify-center p-6 flex-grow',
  merchantNameContainer: 'flex items-center',
  merchantName: 'text-16px font-medium',
  contactInfo: 'flex flex-row mt-6'
}
